import axios from 'axios';
import { Cookies } from 'react-cookie';
import { refreshToken } from 'store/slice/SliceAuth'; // refreshToken 액션 임포트
import { BASE_URL } from 'store/baseConfig';
import { store } from 'index';


const axiosInstance = axios.create({
    baseURL: BASE_URL, // 기본 URL 설정
    withCredentials: true,
});

let isRefreshing = false;
let refreshSubscribers = [];

function onRrefreshed(token) {
    refreshSubscribers.map((callback) => callback(token));
}

function addRefreshSubscriber(callback) {
    refreshSubscribers.push(callback);
}

// 요청 인터셉터
axiosInstance.interceptors.request.use(
    (config) => {
        const cookies = new Cookies();
        const csrfToken = cookies.get('csrftoken');
        if (csrfToken) {
            config.headers['X-CSRFToken'] = csrfToken; // CSRF 토큰 추가
        }

        // loginUserInfo 읽어서 Authorization 헤더에 추가
        const state = store.getState();
        const { loginUserInfo } = state.auth;
        if (loginUserInfo && loginUserInfo.access) {
            config.headers['Authorization'] = `Bearer ${loginUserInfo.access}`; // access 토큰 추가
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 응답 인터셉터
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;

        try{
            const test = error.response.status
        } catch (statusError) {
            return Promise.reject(error.message);
        }
        
        // 401 에러 처리
        if (error.response.status === 401 && !originalRequest._retry) {
            if (isRefreshing) {
                return new Promise((resolve) => {
                    addRefreshSubscriber((token) => {
                        originalRequest.headers['Authorization'] = `Bearer ${token}`;
                        resolve(axiosInstance(originalRequest));
                    });
                });
            }

            originalRequest._retry = true;
            isRefreshing = true;

            const state = store.getState();
            const { loginUserInfo } = state.auth;

            try {
                const newTokens = await store.dispatch(refreshToken()).unwrap();
                isRefreshing = false;
                onRrefreshed(newTokens.access);
                refreshSubscribers = [];

                originalRequest.headers['Authorization'] = `Bearer ${newTokens.access}`;
                return axiosInstance(originalRequest);
            } catch (refreshError) {
                isRefreshing = false;
                refreshSubscribers = [];
                
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
